import { makeAutoObservable } from 'mobx'
import { ChatbotInstructionType, type IChatbotPayload } from '../type'
import { ChatbotAutoFollowUp } from './ChatbotAutoFollowUp'
import { ChatbotBooking } from './ChatbotBooking'
import { ChatbotInstructions } from './ChatbotInstructions'
import { ChatbotKnowledgeBase } from './ChatbotKnowledgeBase'
import { ChatbotTrigger } from './ChatbotTrigger'

export class UnifiedAgent {
  readonly autoFollowUp = new ChatbotAutoFollowUp()
  readonly booking = new ChatbotBooking()
  readonly instructions = new ChatbotInstructions()
  readonly knowledgeBase = new ChatbotKnowledgeBase()
  readonly trigger = new ChatbotTrigger()
  isActive = false

  constructor() {
    makeAutoObservable(this)
  }

  syncOrigin(payload?: IChatbotPayload | null) {
    this.trigger.syncOrigin(payload?.settings)
    this.instructions.syncOrigin(payload?.settings)
    this.booking.syncOrigin(payload?.settings)
    this.autoFollowUp.syncOrigin(payload?.settings)
    this.knowledgeBase.syncOrigin(payload?.settings)
  }

  setActive(isActive: boolean) {
    this.isActive = isActive
  }

  toJSON(): Omit<IChatbotPayload, 'name' | 'send_from' | 'filters' | 'knowledge_base_documents'> {
    return {
      type: ChatbotInstructionType.Unified,
      is_active: this.isActive,
      first_message: { type: 'auto', message: '', media_url: [] },
      fields: [],
      success_actions: null,
      fallback_actions: null,
      qualified_actions: null,
      disqualified_actions: null,
      settings: {
        ...this.instructions.toJSON(),
        ...this.booking.toJSON(),
        ...this.autoFollowUp.toJSON(),
        ...this.trigger.toJSON(),
        ...this.knowledgeBase.toSettingsJSON(),
      },
    }
  }
}
